/**
 * Air Guide — 3-step product finder quiz
 */
(function () {
  function initFinder(root) {
    if (!root || root.dataset.agFinderInit === '1') return;
    root.dataset.agFinderInit = '1';

    var steps = root.querySelectorAll('[data-quiz-step]');
    var nav = root.querySelector('[data-quiz-nav]');
    var result = root.querySelector('[data-quiz-result]');
    var btnNext = root.querySelector('[data-quiz-next]');
    var btnBack = root.querySelector('[data-quiz-back]');
    var btnRestart = root.querySelector('[data-quiz-restart]');
    var labelEl = root.querySelector('[data-quiz-label]');
    var dots = root.querySelectorAll('[data-quiz-dot]');
    var answers = {};
    var step = 1;
    var total = steps.length;

    var results = {};
    root.querySelectorAll('template[data-quiz-result-map]').forEach(function (node) {
      var key = node.getAttribute('data-quiz-result-map');
      if (!key) return;
      results[key] = {
        icon: node.getAttribute('data-icon') || '',
        title: node.getAttribute('data-title') || '',
        why: node.getAttribute('data-why') || '',
        cta: node.getAttribute('data-cta') || '',
        ctaHref: node.getAttribute('data-cta-href') || '#',
        shop: node.getAttribute('data-shop') || '',
        shopHref: node.getAttribute('data-shop-href') || '#',
      };
    });

    function showStep(n) {
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i + 1 === n);
      });
      dots.forEach(function (d, i) {
        var idx = i + 1;
        d.classList.remove('is-active', 'is-done');
        if (idx < n) d.classList.add('is-done');
        if (idx === n) d.classList.add('is-active');
      });
      if (labelEl) labelEl.textContent = 'Question ' + n + ' of ' + total;
      if (btnBack) btnBack.hidden = n <= 1;
      if (btnNext) {
        btnNext.textContent = n === total ? 'See My Recommendation →' : 'Next →';
      }
    }

    function showResult() {
      steps.forEach(function (s) {
        s.classList.remove('is-active');
      });
      if (nav) nav.hidden = true;
      if (result) {
        result.classList.add('is-active');
        var key = answers.q1 || 'general';
        var r = results[key] || results.general || {};
        var icon = result.querySelector('[data-result-icon]');
        var title = result.querySelector('[data-result-title]');
        var why = result.querySelector('[data-result-why]');
        var cta = result.querySelector('[data-result-cta-primary]');
        var shop = result.querySelector('[data-result-cta-shop]');
        if (icon) icon.textContent = r.icon;
        if (title) title.textContent = r.title;
        if (why) why.textContent = r.why;
        if (cta) {
          cta.textContent = r.cta;
          cta.href = r.ctaHref;
        }
        if (shop) {
          shop.textContent = r.shop;
          shop.href = r.shopHref;
        }
      }
    }

    function restart() {
      step = 1;
      answers = {};
      if (result) result.classList.remove('is-active');
      if (nav) nav.hidden = false;
      root.querySelectorAll('.ag-quiz__opt').forEach(function (o) {
        o.classList.remove('is-selected');
      });
      showStep(1);
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-opt]');
      if (opt && root.contains(opt)) {
        var group = opt.closest('[data-quiz-step]');
        if (!group) return;
        var stepKey = group.getAttribute('data-quiz-step');
        group.querySelectorAll('[data-quiz-opt]').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        opt.classList.add('is-selected');
        answers[stepKey] = opt.getAttribute('data-value') || '';
      }
    });

    if (btnNext) {
      btnNext.addEventListener('click', function () {
        if (step < total) {
          step++;
          showStep(step);
        } else {
          showResult();
        }
      });
    }

    if (btnBack) {
      btnBack.addEventListener('click', function () {
        if (step > 1) {
          step--;
          showStep(step);
        }
      });
    }

    if (btnRestart) {
      btnRestart.addEventListener('click', restart);
    }

    showStep(1);
  }

  function init() {
    document.querySelectorAll('[data-ag-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
